// Minimal tracker for the "Self Doubling Growing Circle" homepage CTA.
//
// Reuses the existing /api/track infrastructure — no new subsystem. Fires
// a single tracking_events document with `event=circle_cta_click`, carries
// the ?ref= / UTM attribution snapshot so the funnel and Sources sections
// can attribute the click to its source. Fire-and-forget; never blocks
// navigation and never surfaces errors to the user.

import axios from "axios";
import { attributionForPayload } from "./attribution";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function trackCircleCta(location) {
  try {
    axios.post(`${API}/track`, {
      event: "circle_cta_click",
      cta_location: location || "unknown",
      utm: attributionForPayload(),
      referrer: (typeof document !== "undefined" && document.referrer) || null,
      path: (typeof window !== "undefined" && window.location.pathname) || null,
    }).catch(() => {});
  } catch {
    /* never block navigation */
  }
}
